export class WebGPURenderer {
  constructor() {
    throw new Error('WebGPURenderer is disabled in this WebGL build.')
  }
}
